export const structure = [
  {
    name: 'Class A',
    criteria: 'Salary',
    description: ''
  },
  {
    name: 'Class B',
    criteria: 'Location',
    description: ''
  },
  {
    name: 'Class B',
    criteria: 'Location',
    description: ''
  },{
    name: 'Class B',
    criteria: 'Location',
    description: ''
  },{
    name: 'Class B',
    criteria: 'Location',
    description: ''
  },{
    name: 'Class B',
    criteria: 'Location',
    description: ''
  },
]
